import { render, staticRenderFns } from "./VaRedirectBlock.vue?vue&type=template&id=f70c6266&scoped=true&"
import script from "./VaRedirectBlock.vue?vue&type=script&lang=js&"
export * from "./VaRedirectBlock.vue?vue&type=script&lang=js&"
import style0 from "./VaRedirectBlock.vue?vue&type=style&index=0&id=f70c6266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c6266",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
